import React, { useState, useEffect, useCallback } from 'react';
import Iframe2 from './wbs2iframe.jsx';
import Iframerows from './wbs2iframe-row.jsx';
import './styledatatable.css';
import 'bootstrap/dist/css/bootstrap.min.css';
// import Checklist from './iconpages/checklist.jsx'; // Unused
import { useLocation } from 'react-router-dom';
// import nusLogo from './img/nus-logo.webp'; // Unused
import Wbs2iframesync from './wbs2iframe-sync.jsx';
import Loa from './loapoiframe.jsx';
import { queuedApiFetch } from './api'; // Removed unused apiFetch
import FullscreenLoader from './FullscreenLoader';

function Funds() {
  const location = useLocation();
  const [activeComponent, setActiveComponent] = useState("AddWBS");
  const [userCompany, setUserCompany] = useState(null);
  const [userPermission, setUserPermission] = useState(null);
  const [userRoleManual, setUserRolesManual] = useState(null);
  const [loading, setLoading] = useState(true);
  const [proj_access_level, setProjAccessLevel] = useState(false);

  // --- Initial Data Parsing ---
  const getProjectDetails = localStorage.getItem('projectDetails');
  const selectedProjectDetail = getProjectDetails ? JSON.parse(getProjectDetails) : {};
  const projectName = selectedProjectDetail.projectName || 'Project Name';
  const defaultProjectNumber = selectedProjectDetail.projectNumber;

  const getUserDetails = localStorage.getItem('userDetails');
  const userDetails = getUserDetails ? JSON.parse(getUserDetails) : {};
  const userId = userDetails.id || '';
  const getUserEmail = localStorage.getItem('userEmail') || '';
  
  // Parameter for API calls and URL
  let parametervalue = userCompany === "NUS" ? 1 : 0;

  // Derive QS parameters once
  // Use optional chaining for safe access
  let p_access = selectedProjectDetail.Proj_Access?.proj_access_level; 
  let p_roles = selectedProjectDetail.Proj_Access?.proj_role?.join(", ") || '';
  let proj_name=selectedProjectDetail?.projectName;
  const qs_params = `nususer=${parametervalue}&project_admin=${(p_access) ? 1 : 0}&project_roles=${encodeURIComponent(p_roles)}&project_name=${proj_name}`;
  // ---------------------------------------------
  
  // Memoized function for fetching project role
  const fetchUserRole = useCallback(async (projectNumber, userID) => {
    const requestOptions = { method: 'GET' };
    try {
      const response = await queuedApiFetch(`/project/get_project_role?userid=${userID}&projectid=${projectNumber}`, requestOptions);
      const data = response;
      if (data.apistatus?.Status_Code === 200 && data.apistatus.Status_Description?.toLowerCase() === 'success') {
        setUserRolesManual(data.data);
        setProjAccessLevel(data.access_level);
      }
    } catch (error) {
      console.error('Error fetching user role:', error);
      // Fallback for permissions if API fails
      setUserRolesManual([]); 
      setProjAccessLevel(false);
    }
  }, []);

  // Memoized function for fetching user company/permission
  const fetchUserCompany = useCallback(async (email) => {
    const requestOptions = { method: 'GET' };
    try {
      const response = await queuedApiFetch(`/user/getuserprofile?emailid=${email}`, requestOptions);
      const data = response;
      if (data.apistatus?.Status_Code === 200 && data.apistatus.Status_Description?.toLowerCase() === 'success') {
        setUserCompany(data.data.company_name);
        setUserPermission(data.data.access_level);
      }
    } catch (error) {
      console.error('Error fetching user company:', error);
      // Fallback for permissions if API fails
      setUserCompany(''); 
      setUserPermission('');
    }
  }, []);

  // --- 1. EFFECT HOOK FOR CONCURRENT DATA FETCHING ---
  useEffect(() => {
    const fetchData = async () => {
      // Set loading true to block rendering until data is fetched
      setLoading(true); 
      try {
        // Use Promise.all for faster, concurrent fetching of independent data
        await Promise.all([
          fetchUserCompany(getUserEmail),
          fetchUserRole(defaultProjectNumber, userId)
        ]);
        // State updates are initiated here, but the component hasn't re-rendered yet.
      } catch (error) {
        console.error("Error in fetchData:", error);
      } finally {
        // This ensures loading is false only after both API calls complete
        setLoading(false); 
      }
    };

    if (userId && defaultProjectNumber && getUserEmail) {
        fetchData();
    }
    // Dependencies are the memoized fetch functions and stable IDs/Emails
  }, [fetchUserCompany, fetchUserRole, userId, defaultProjectNumber, getUserEmail]);


  // // --- 2. EFFECT HOOK FOR INITIAL COMPONENT ACTIVATION (The Fix) ---
  // useEffect(() => {
  //   // This runs AFTER the component has re-rendered with new permissions (i.e., loading is false)
  //   if (!loading && userCompany !== null && userRoleManual !== null) {
  //     // The DOM should now have the correct 'cur_vis' class applied.
  //     const btn = document.querySelector('.sub-btn.cur_vis');
  //     if (btn) {
  //       // console.log("Found and clicking button:", btn); // Optional logging
  //       btn.click();
  //     } else {
  //       // Fallback: If no role-specific button is visible, default to 'AddWBS' 
  //       // to ensure *something* loads, or handle as per design requirements.
  //       setActiveComponent("AddWBS");
  //     }
  //   }
  //   // Triggers when loading is finished AND the user data is set.
  // }, [loading, userCompany, userRoleManual]); 


  // // --- Route Parameter Effect ---
  // useEffect(() => {
  //   const getSearch = location.search;
  //   if (getSearch.includes('add-wbs')) {
  //     setActiveComponent('AddWBS');
  //   } else if (getSearch.includes('add-new-row')) {
  //     setActiveComponent('AddNewRow');
  //   } else if (getSearch.includes('sync-acc')) {
  //     setActiveComponent('SyncToACC');
  //   } else if (getSearch.includes('lop')) {
  //     setActiveComponent('loapoi');
  //   } else if (getSearch.includes('cost-summary')) {
  //     setActiveComponent('costsummary');
  //   }
  // }, [location]);


  // --- 2. EFFECT HOOK FOR INITIAL COMPONENT ACTIVATION ---
  useEffect(() => {
    if (!loading && userCompany !== null && userRoleManual !== null) {

      // Read active query parameter
      const searchParams = new URLSearchParams(location.search);
      const active = searchParams.get('active');

      // If URL already specifies page, do not override it
      if (active === 'add-new-row') {
        setActiveComponent('AddNewRow');
        return;
      }

      if (active === 'add-wbs') {
        setActiveComponent('AddWBS');
        return;
      }

      if (active === 'sync-acc') {
        setActiveComponent('SyncToACC');
        return;
      }

      if (active === 'lop') {
        setActiveComponent('loapoi');
        return;
      }

      // Default behavior only when no query parameter exists
      const btn = document.querySelector('.sub-btn.cur_vis');

      if (btn) {
        btn.click();
      } else {
        setActiveComponent("AddWBS");
      }
    }
  }, [loading, userCompany, userRoleManual, location.search]);

  useEffect(() => {
  const searchParams = new URLSearchParams(location.search);
  const active = searchParams.get('active');

  switch (active) {
    case 'add-wbs':
      setActiveComponent('AddWBS');
      break;

    case 'add-new-row':
      setActiveComponent('AddNewRow');
      break;

    case 'sync-acc':
      setActiveComponent('SyncToACC');
      break;

    case 'lop':
      setActiveComponent('loapoi');
      break;

    case 'cost-summary':
      setActiveComponent('costsummary');
      break;

    default:
      break;
  }
}, [location.search]);

  
  // --- Permission Checker Logic ---
  const nus_role_sts = (expectedCompany, projectAdminRoles = []) => {
    // Return false until data is fully loaded
    if (loading || userCompany === null || userRoleManual === null) return false; 
    
    return (
      (userCompany === expectedCompany && proj_access_level === true) ||
      projectAdminRoles.some(item => userRoleManual?.includes?.(item))
    );
  };

   if (loading) {
      return <FullscreenLoader />;
    }
  
  // --- Component Renderer ---
  const renderComponent = () => {
    if(loading) return <div className="loading-spinner">Loading Project and User Data...</div>; 
    
    switch (activeComponent) {
      case "AddWBS":
        return <div><Iframe2 /></div>;
      case "AddNewRow":
        return <div><Iframerows propwidth={"100%"} /></div>;
      case "SyncToACC":
        return <div><Wbs2iframesync /></div>;
      case "loapoi":
        return <div><Loa /></div>;
      default:
        // Default to AddWBS if state is not explicitly set
        return <div><Iframe2 /></div>; 
    }
  };

  return (
    <div className="wbshor">
      <div className="login-header-wrap">
        <div className="login-header">
          <div className="pagetitle">{projectName}</div>
          <div className="button-wrapper">
            <div className="options-popup" id="optionsPopup">
              <button className="option-btn yellow">Filter ↓</button>
              <button className="option-btn">Export PIF ↓</button>
              <button className="option-btn">Hide Columns ↓</button>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="innerwrap">
          <div className="leftbar">
            {/* PIF Section Button */}
            <button 
                className={`option-btn btn1 ${activeComponent === "AddWBS" || activeComponent === "AddNewRow" || activeComponent === "SyncToACC" ? 'active' : ''}`}
                onClick={() => setActiveComponent("AddWBS")}>
              PIF
            </button>
            {/* Funding Table Sub-Buttons */}
            <div className="sub1" style={{ display: 'flex' }}>
              <button
                className={`sub-btn ${nus_role_sts("NUS", ['Admin']) ? 'cur_vis' : ''} ${activeComponent === "AddWBS" ? 'active' : ''}`}
                style={{ display: nus_role_sts("NUS", ['Admin']) ? 'block' : 'none' }}
                onClick={() => setActiveComponent("AddWBS")}
              >
                Add WBS
              </button>
              <button
                className={`sub-btn ${nus_role_sts("NUS", ['Project Manager (PM)']) ? 'cur_vis' : ''} ${activeComponent === "AddNewRow" ? 'active' : ''}`}
                style={{ display: nus_role_sts("NUS", ['Project Manager (PM)']) ? 'block' : 'none' }}
                onClick={() => setActiveComponent("AddNewRow")}
              >
                {/* Add New Row */}
                Add/Edit Entry
              </button>
              <button
                className={`sub-btn ${nus_role_sts("NUS", ['Admin & Contract (AC)']) ? 'cur_vis' : ''} ${activeComponent === "SyncToACC" ? 'active' : ''}`}
                style={{ display: nus_role_sts("NUS", ['Admin & Contract (AC)']) ? 'block' : 'none' }}
                onClick={() => setActiveComponent("SyncToACC")}
              >
                Sync to ACC
              </button>
            </div>

            {/* LOA/PO Table Button */}
            <button
              className={`option-btn btn1 ${activeComponent === "loapoi" ? 'active' : ''}`}
              style={{ display: nus_role_sts("NUS", ['Project Manager (PM)', 'Admin']) ? 'block' : 'none' }}
              onClick={() => setActiveComponent("loapoi")}>
              LOA/PO Table
            </button>

            {/* Cost Summary Button */}
            <button
              className={`option-btn btn1 ${activeComponent === "costsummary" ? 'active' : ''}`}
              style={{ display: nus_role_sts("NUS", ['Project Manager (PM)']) ? 'block' : 'none' }}
              onClick={() => {
                window.location.replace(`https://acc.autodesk.com/cost/cost/projects/${defaultProjectNumber}/contracts?${qs_params}&menu=costsummary`);
                setActiveComponent("costsummary");
              }}
            >
              Cost Summary
            </button>

            {/* Payments Button */}
            <button
              className={`option-btn btn1 ${activeComponent === "Payments" ? 'active' : ''}`}
              style={{ display: nus_role_sts("NUS", ['Project Manager (PM)']) ? 'block' : 'none' }}
              onClick={() => {
                window.location.replace(`https://acc.autodesk.com/cost/cost/projects/${defaultProjectNumber}/cost-payments/list?${qs_params}&menu=Payments`);
                setActiveComponent("Payments");
              }}
            >
              Payments
            </button>
          </div>
          <div className="content">
            {renderComponent()}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Funds;